<template>
  <div>
    <template v-if="conversations">
      <conversation-item
        v-for="conversation of conversations"
        :key="conversation.id"
        :conversation="conversation"
        @deleted="handleDeleted"
      />
      <div
        v-if="conversations.length === 0"
        class="container"
      >
        You have no messages here.
      </div>
    </template>
    <spinner
      v-else-if="conversations.loading"
      preset="large"
    />
    <div
      v-else-if="conversations.error"
      class="container"
    >
      <div
        class="alert alert-danger"
        role="alert"
      >
        An error occurred while trying to load the messages. Please check your
        connection and try again.
      </div>

      <button
        type="button"
        class="btn btn-outline-primary"
        @click="loadConversations"
      >
        Try Again
      </button>
    </div>
  </div>
</template>

<script>
import ConversationItem from './ConversationItem.vue';

export default {
  components: {
    ConversationItem,
  },
  props: {
    listType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      status: 'loading',
    };
  },
  computed: {
    conversations() {
      return this.$root.chatConversations.slice().reverse();
    },
  },
  methods: {
    handleDeleted(item) {
      const idx = this.$root.chatConversations.findIndex(c => c.room === item.room);
      if (idx > -1) {
        this.$root.chatConversations.splice(idx, 1);
      }
    },
  },
};
</script>
